// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e54e3d12","232":"d20a4545","237":"8dd4637e","526":"2f811889","787":"30237536","872":"184e6471"}[chunkId] + ".chunk.js";
};